import moment from "moment";
import { useDates } from "../../../dates/DatesContext";
import { ProductExpander } from "./ProductExpander";
import AdvertisementExpander from "../../../modules/advertising/components/AdvertisementExpander";

export const AnnotationExpander = ({ row }) => {
  const { group } = useDates();

  const { annotation_type: annotationType, advertisement, product, ts } = row.original;

  const annotationDate = moment(ts.slice(0, 10));
  const daysSinceAnnotation = moment().diff(annotationDate, "days");
  const chartStartDate =
    annotationType?.includes("CREATED") ?
      moment(annotationDate).format("YYYY-MM-DD")
    : moment(annotationDate).subtract(daysSinceAnnotation, "days").format("YYYY-MM-DD");

  // Formatted like the chart's dates (each period's start_date), which the highlight is matched against
  const getHighlightDate = (date) => {
    switch (group) {
      case "month":
        return moment(date).startOf("month").format("YYYY-MM-DD");
      case "week":
        // Offset so week begins on Sunday to align with datamart
        return moment(date).startOf("week").add(1, "d").format("YYYY-MM-DD");
      case "day":
      default:
        return moment(date).format("YYYY-MM-DD");
    }
  };

  if (product?.id) {
    return (
      <ProductExpander
        product={product}
        chartStartDate={chartStartDate}
        highlightDate={getHighlightDate(annotationDate)}
      />
    );
  }

  return <AdvertisementExpander adId={advertisement?.id} highlightDate={getHighlightDate(annotationDate)} />;
};
